import { inject, Injectable } from '@angular/core';

import { TASK_MAPPERS, TaskMapper } from '../contracts/task-mapper.contract';
import { TaskDataMap, TaskResponse, TaskType } from '../models/task.interface';

@Injectable()
export class TaskMapperRegistry {
  private readonly mappersByType = new Map<TaskType, TaskMapper>();

  constructor() {
    const mappers = inject(TASK_MAPPERS, { optional: true }) ?? [];
    for (const mapper of mappers) {
      this.mappersByType.set(mapper.type, mapper);
    }
  }

  get(type: TaskType): TaskMapper | null {
    return this.mappersByType.get(type) ?? null;
  }

  map(type: TaskType, r: TaskResponse): TaskDataMap[TaskType] {
    const mapper = this.get(type);
    if (!mapper) {
      return {} as TaskDataMap[TaskType.Custom];
    }
    return mapper.map(r);
  }
}
